<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { emitter } from 'shared/helpers/mitt';
import EmailTranscriptModal from './EmailTranscriptModal.vue';
import ResolveAction from '../../buttons/ResolveAction.vue';
import {
  CMD_MUTE_CONVERSATION,
  CMD_SEND_TRANSCRIPT,
  CMD_UNMUTE_CONVERSATION,
} from 'dashboard/helper/commandbar/events';
import ContactAPI from 'dashboard/api/contacts';
import { useAccount } from 'dashboard/composables/useAccount';
import CreateTicket from 'dashboard/routes/dashboard/conversation/contact/CreateTicket.vue';


export default {
  components: {
    EmailTranscriptModal,
    ResolveAction,
    CreateTicket
  },
  setup() {
    const { accountId } = useAccount();

    return {
      accountId,
    };
  },
  data() {
    return {
      showEmailActionsModal: false,
      showCreateTicketModal: false,
      conversationStatus: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters({ currentChat: 'getSelectedChat' }),
  },
  watch: {
    'currentChat.id': {
      immediate: true,
      handler() {
        if (this.currentChat.id) {
          ContactAPI.getConversationStatus({
            conversation_id: this.currentChat.id,
            account_id: this.accountId,
            inbox_id: this.currentChat.inbox_id,
          })
            .then(response => {
              this.conversationStatus = response.data.active_bot;
            })
            .catch(() => {
              this.conversationStatus = false;
            });
        }
      },
    },
    'currentChat.status': {
      handler() {
        if (this.currentChat.status === 'resolved') {
          this.conversationStatus = true;
        }
      },
    },
  },
  mounted() {
    emitter.on(CMD_MUTE_CONVERSATION, this.mute);
    emitter.on(CMD_UNMUTE_CONVERSATION, this.unmute);
    emitter.on(CMD_SEND_TRANSCRIPT, this.toggleEmailActionsModal);
  },
  unmounted() {
    emitter.off(CMD_MUTE_CONVERSATION, this.mute);
    emitter.off(CMD_UNMUTE_CONVERSATION, this.unmute);
    emitter.off(CMD_SEND_TRANSCRIPT, this.toggleEmailActionsModal);
  },
  methods: {
    mute() {
      this.$store.dispatch('muteConversation', this.currentChat.id);
      useAlert(this.$t('CONTACT_PANEL.MUTED_SUCCESS'));
    },
    unmute() {
      this.$store.dispatch('unmuteConversation', this.currentChat.id);
      useAlert(this.$t('CONTACT_PANEL.UNMUTED_SUCCESS'));
    },
    toggleEmailActionsModal() {
      this.showEmailActionsModal = !this.showEmailActionsModal;
    },
    toggleCreateTicketModal() {
      this.showCreateTicketModal = !this.showCreateTicketModal;
    },
    onChangeConversationStatus(checked) {
      if (this.loading) return;
      this.loading = true
      ContactAPI.changeConversationStatus({
        conversation_id: this.currentChat.id,
        account_id: this.accountId,
        active_bot: checked,
      })
        .then(() => {
          this.conversationStatus = checked;
        })
        .catch(() => {
          useAlert("Thay đổi trạng thái bot thất bại")
        })
        .finally(() => this.loading = false);
    },
  },
};
</script>

<template>
  <div class="relative flex items-center gap-2 actions--container">
    <!-- <input
      v-tooltip="'Enable/Disable Bot'"
      :value="conversationStatus"
      :checked="conversationStatus"
      class="checkbox"
      type="checkbox"
      @change="onChangeConversationStatus($event.target.checked)"
    /> -->
    <woot-button
      icon="add"
      @click="toggleCreateTicketModal"
    >
      Tạo ticket
    </woot-button>
    <woot-button
      :color-scheme="conversationStatus ? 'alert' : 'success'"
      :icon="conversationStatus ? 'dismiss' : 'checkmark'"
      @click="onChangeConversationStatus(!conversationStatus)"
    >
      {{ conversationStatus ? 'Tắt Bot' : 'Bật Bot' }}
    </woot-button>
    <woot-button
      v-if="!currentChat.muted"
      v-tooltip="$t('CONTACT_PANEL.MUTE_CONTACT')"
      variant="clear"
      color-scheme="secondary"
      icon="speaker-mute"
      @click="mute"
    />
    <woot-button
      v-else
      v-tooltip.left="$t('CONTACT_PANEL.UNMUTE_CONTACT')"
      variant="clear"
      color-scheme="secondary"
      icon="speaker-1"
      @click="unmute"
    />
    <woot-button
      v-tooltip="$t('CONTACT_PANEL.SEND_TRANSCRIPT')"
      variant="clear"
      color-scheme="secondary"
      icon="share"
      @click="toggleEmailActionsModal"
    />
    <ResolveAction
      :conversation-id="currentChat.id"
      :status="currentChat.status"
    />
    <EmailTranscriptModal
      v-if="showEmailActionsModal"
      :show="showEmailActionsModal"
      :current-chat="currentChat"
      @cancel="toggleEmailActionsModal"
    />
     <CreateTicket
      :show="showCreateTicketModal"
      @cancel="toggleCreateTicketModal"
    />
  </div>
</template>

<style scoped lang="scss">
.more--button {
  @apply items-center flex ml-2 rtl:ml-0 rtl:mr-2;
}

.dropdown-pane {
  @apply -right-2 top-12;
}

.icon {
  @apply mr-1 rtl:mr-0 rtl:ml-1 min-w-[1rem];
}
</style>
